export default [
    {
        displayName: "None",
        target: null,
        range: null,
        peak: null,
    },
    {
        displayName: "-13 LUFS",
        target: -13,
        range: 7,
        peak: -2,
    },
    {
        displayName: "-16 LUFS",
        target: -16,
        range: 7,
        peak: -2,
    },
    {
        displayName: "-23 LUFS, EBU R 128",
        target: -23,
        range: 7,
        peak: -2,
    },
    {
        displayName: "-24 LUFS, ATSC A/85",
        target: -24,
        range: 7,
        peak: -2,
    },
];
